// src/hooks/useReportsData.js

import { useState, useEffect, useCallback } from 'react';
import { parseCSV } from '../utils/csvParser';
import { parseReportsPallets } from '../utils/reportsParser';
import { SHEET_CONFIG, getSheetCsvUrl } from '../constants';

export const useReportsData = () => {
  const [pallets, setPallets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [error, setError] = useState('');

  const fetchData = useCallback(async (bustCache = false) => {
    setError('');

    try {
      const response = await fetch(
        getSheetCsvUrl(SHEET_CONFIG.REPORTS_SHEET, {
          gid: SHEET_CONFIG.REPORTS_SHEET_GID,
          bustCache,
        })
      );

      if (!response.ok) {
        throw new Error(`Unable to load records. Status: ${response.status}`);
      }

      const rows = parseCSV(await response.text(), { headerRow: false });
      setPallets(parseReportsPallets(rows));
    } catch (err) {
      console.error('Reports data fetch error:', err);
      setError(err.message || 'Unable to load records.');
    }
  }, []);

  useEffect(() => {
    setLoading(true);
    fetchData().finally(() => setLoading(false));
  }, [fetchData]);

  const refreshData = useCallback(async () => {
    setRefreshing(true);
    await fetchData(true);
    setRefreshing(false);
  }, [fetchData]);

  return { pallets, loading, refreshing, error, refreshData };
};
